// Copyright (c) 2025 Just Feasible Solutions LLC. All rights reserved.
// This file is part of the Just Feasible Solutions application.
// Unauthorized copying, distribution, or modification of this file is prohibited.
// For license information, contact the author.

import React, { useState, useEffect } from 'react';

const defaultSettings = {
  analytics: true,
  marketing: false,
  preferences: true,
};

const CookiesSetting = () => {
  const [settings, setSettings] = useState(() => {
    const saved = localStorage.getItem('Just Feasible Solutions_cookies');
    return saved ? JSON.parse(saved) : defaultSettings;
  });
  const [savedMsg, setSavedMsg] = useState('');

  useEffect(() => {
    localStorage.setItem('Just Feasible Solutions_cookies', JSON.stringify(settings));
  }, [settings]);

  const handleChange = e => {
    const { name, checked } = e.target;
    setSettings(s => ({ ...s, [name]: checked }));
  };

  const handleSave = e => {
    e.preventDefault();
    localStorage.setItem('Just Feasible Solutions_cookies', JSON.stringify(settings));
    setSavedMsg('Your cookie preferences have been saved.');
    setTimeout(() => setSavedMsg(''), 2500);
  };

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '2rem' }}>
      <h1>Cookie Settings</h1>
      <form onSubmit={handleSave}>
        <div style={{ marginBottom: 18 }}>
          <label>
            <input type="checkbox" name="analytics" checked={settings.analytics} onChange={handleChange} />
            <span style={{ marginLeft: 8 }}>Allow analytics cookies (helps us improve the app)</span>
          </label>
        </div>
        <div style={{ marginBottom: 18 }}>
          <label>
            <input type="checkbox" name="marketing" checked={settings.marketing} onChange={handleChange} />
            <span style={{ marginLeft: 8 }}>Allow marketing cookies (personalized offers and ads)</span>
          </label>
        </div>
        <div style={{ marginBottom: 18 }}>
          <label>
            <input type="checkbox" name="preferences" checked={settings.preferences} onChange={handleChange} />
            <span style={{ marginLeft: 8 }}>Allow preferences cookies (remembers your settings)</span>
          </label>
        </div>
        <button type="submit" style={{ padding: '8px 20px', background: '#1976d2', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 600, fontSize: '1rem', cursor: 'pointer' }}>
          Save Preferences
        </button>
        {savedMsg && <div style={{ color: '#1a7f37', marginTop: 16 }}>{savedMsg}</div>}
      </form>
      <p style={{ color: '#555', marginTop: 24, fontSize: '0.97rem' }}>
        You can change your cookie preferences at any time. Some cookies are necessary for the app to function and cannot be disabled.
      </p>
    </div>
  );
};

export default CookiesSetting;
